"use client";

import Cookies from "js-cookie";
import { useMemo } from "react";
import VehicleForm from "./VehicleForm";
import VehicleDetail from "./VehicleDetail";
import { useTranslation } from "@/i18n/client";
import { showVehicleInfo } from "@/lib/utils/functions";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { updateVehicle } from "@/lib/store/reducers/vehicle";

const CarRegistrationBox = ({ cookieKeys }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["garage", "common"]);
  const { vehicle } = useAppSelector((state) => state.vehicle);
  const vInfo = useMemo(() => {
    return { detail: showVehicleInfo(vehicle), selected: !!vehicle };
  }, [vehicle]);

  const handleChangeVehicle = () => {
    dispatch(updateVehicle(null));
    Cookies.remove(cookieKeys.new_vehicle);
    Cookies.remove(cookieKeys.manual_lookup);
    Cookies.remove(cookieKeys.selectedVehicle);
  };

  return (
    <div
      className={`carRegistrationBox ${
        vInfo.selected ? "slide-in-top" : "slide-in-bottom"
      }`}
    >
      {vInfo.selected ? (
        <VehicleDetail
          t={t}
          vehicle={vInfo.detail}
          handleChangeVehicle={handleChangeVehicle}
        />
      ) : (
        <VehicleForm t={t} />
      )}
    </div>
  );
};

export default CarRegistrationBox;
